<template>
    <div><!-- 訂單變更查詢 -->
        <SearchBar  :searchType="searchType"  @doChangeOrderSearch="doChangeOrderSearch"/>
        <CCard>
            <CCardBody>
                <div class="table-container">
                    <vue-bootstrap4-table ref="changeOrderSearchBs4Table" class="" 
                        :rows="orderSearchObj.rows" 
                        :columns="columns" 
                        @on-change-query="onChangeQuery"
                        :total-rows="orderSearchObj.totalCount"
                        :config="config" :classes="classes" >
                        <template v-if="isTw" slot="empty-results">
                            查無結果
                        </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                            {{paginationInfoTwText(props)}}
                        </template>
                        <template slot="func" slot-scope="props">
                            <!-- 
                            <button class="btn btn-sm btn-success mr-2" @click="detail(props.row.proid)">{{i18n('Buttons.DetailInfo')}}</button>
                            <button class="btn btn-sm btn-primary" :disabled="disableChangeInfoBtn(props.row)" v-if="!isEmployee" @click="changeConfirmInfo(props.row)">{{i18n('Buttons.ChangeOrderInfo')}}</button> 
                            -->
                            <button class="btn btn-sm btn-success mr-2" @click="detail(props.row.proid)">{{btnText(props.row)}}</button>
                        </template>
                    </vue-bootstrap4-table>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import SearchBar from '../Order/OrderSearch/SearchBar.vue'
import { orderMixin } from '@/mixin/order'
export default {
    components: {
        SearchBar,
    },
    mixins: [orderMixin],
    data() {
        return {
            searchType: 'ChangeOrder'
        }
    },
    props : {
    },
    methods: {
        doChangeOrderSearch (orderQueryParam){ 
            if(this.$refs.changeOrderSearchBs4Table){
                this.$refs.changeOrderSearchBs4Table.page = 1
            }           
           this.doOrderSearch(orderQueryParam ,true);
        },
        detail(id) { // 詳細資訊
            sessionStorage.setItem('orderId', id);
            this.$router.push('changeorderinformation');            
        },
        // changeConfirmInfo(item) { // 變更確認
        //     //sessionStorage.setItem('orderId', id);
        //     //this.$router.push('changeorderinformation'); 
        //     const url = `${this.$apiUrl_Order}/ChangeOrderConfirm`
        //     const param = {proid : item.proid};
        //     this.updateLoading(true);
        //     this.axios.post(url, param).then((response) => {
        //         const {status , statusMessage} = response.data;
        //         this.updateLoading(false);
        //         if(status){
        //             this.$alert(statusMessage,'警告',{type: 'warning'});
        //         }else{                    
        //             //--成功          
        //             item.confirmTime = new Date().yyyymmdd();    
        //         }                    
        //     });           
        // },
        disableChangeInfoBtn (item){            
            if(this.isEmployee){
                return true;
            }
            if(item && item.confirmTime){
                return true;
            }
            return false;
        },
        btnText (item){
            if(this.isMember){
               if(!item.confirmTime){
                   return this.i18n('Buttons.ChangeOrderInfo');
               }
            }
            return this.i18n('Buttons.DetailInfo');
        }
    },
    computed: {       
        isEmployee() {            
            return this.$store.state.isEmployee;            
        }
    },
    mounted() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
</style>
